import { c as _c } from "react/compiler-runtime";
import { classNames, SkeletonLine, TableCell, TableRow } from "@opensea/ui-kit";
import { TABLE_COLUMN_CLASSNAMES } from "./styles";
export function ItemAttributesTableSkeletonRow(t0) {
  const $ = _c(26);
  const {
    item
  } = t0;
  const overrides = item?.overrides;
  const t1 = overrides?.Skeleton?.className;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("h-4 w-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <TableCell className={TABLE_COLUMN_CLASSNAMES.attribute}><SkeletonLine className={t2} /></TableCell>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = overrides?.Skeleton?.className;
  let t5;
  if ($[4] !== t4) {
    t5 = classNames("h-4 w-full", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <TableCell className={TABLE_COLUMN_CLASSNAMES.trait}><SkeletonLine className={t5} /></TableCell>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = overrides?.Skeleton?.className;
  let t8;
  if ($[8] !== t7) {
    t8 = classNames("h-4 w-full", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <TableCell className={TABLE_COLUMN_CLASSNAMES.count}><SkeletonLine className={t8} /></TableCell>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = overrides?.Skeleton?.className;
  let t11;
  if ($[12] !== t10) {
    t11 = classNames("h-4 w-full", t10);
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <TableCell className={TABLE_COLUMN_CLASSNAMES.floor}><SkeletonLine className={t11} /></TableCell>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = overrides?.Skeleton?.className;
  let t14;
  if ($[16] !== t13) {
    t14 = classNames("h-4 w-full", t13);
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t14) {
    t15 = <TableCell className={TABLE_COLUMN_CLASSNAMES.topOffer}><SkeletonLine className={t14} /></TableCell>;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t12 || $[21] !== t15 || $[22] !== t3 || $[23] !== t6 || $[24] !== t9) {
    t16 = <TableRow>{t3}{t6}{t9}{t12}{t15}</TableRow>;
    $[20] = t12;
    $[21] = t15;
    $[22] = t3;
    $[23] = t6;
    $[24] = t9;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}